<template>
    <section>
      <el-form :model="formObj" :rules="formRules" ref="formObj" label-width="120px">
        <el-form-item label="项目" v-if="proList.length>0" prop="proId">
          <el-select v-model="proId" placeholder="请选择项目" @change="proChange">
            <el-option v-for="(item,index) in proList" :key="item.id" :value="item.id" :label="item.proName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备名称" prop="deviceName">
          <el-input v-model="formObj.deviceName" placeholder="请输入名称" maxlength="20"  show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="设备型号" prop="deviceType">
          <el-input v-model="formObj.deviceType" placeholder="请输入型号" maxlength="20"  show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="租赁厂家" prop="deviceFactory">
          <el-input v-model="formObj.deviceFactory" placeholder="请输入厂家名称" maxlength="50"  show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="使用范围" prop="deviceRange">
          <el-input v-model="formObj.deviceRange" placeholder="请输入使用范围" maxlength="50"  show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="安装时间" prop="deviceInstallTime">
          <el-date-picker
            v-model="formObj.deviceInstallTime"
            type="datetime"
            placeholder="选择时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="检测合格时间" prop="deviceCheckTime">
          <el-date-picker
            v-model="formObj.deviceCheckTime"
            type="datetime"
            placeholder="选择时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="关联司机">
          <el-select v-model="driver" placeholder="关联司机">
            <el-option  v-for="(item,index) in drivers" :key="item.id" :label="item.employeeName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关联指挥">
          <el-select v-model="commander" placeholder="关联司机">
            <el-option  v-for="(item,index) in commanders" :key="item.id" :label="item.employeeName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上传附件">
          <el-upload
            class="upload-demo"
            :action="this.GLOBAL.baseServerPath+'/fileupload'"
            :headers="this.GLOBAL.fileHeader"
            name="file"
            :file-list="fileList"
            :limit="1"
            :on-exceed="handleExceed"
            :on-remove="removeConUpload"
            :on-success="successConUpload">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip"></div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button @click.native="doCancel">取消</el-button>
        <el-button type="primary" @click.native="doSubmit(option)">确定</el-button>
      </div>
    </section>
</template>

<script>
  import {deviceCreate, deviceUpdate,tagRoles,proSearch,workers} from '../../api/api'
  import WorkTeamList from "../command/WorkTeamList";
  export default {
    components: {WorkTeamList},
    props: {
      option: 0,
      formData:{},
      type:0
    },
    data () {
      return {
        fileList: [],
        formObj: {},
        formRules: {
          proId: [
            {required: true, message: '请选择项目', trigger: 'blur'}
          ],
          deviceName: [
            {required: true, message: '请输入设备名称', trigger: 'blur'}
          ],
          deviceType: [
            {required: true, message: '请输入设备型号', trigger: 'blur'}
          ],
          deviceFactory: [
            {required: true, message: '请输入租赁厂家', trigger: 'blur'}
          ],
          deviceRange: [
            {required: true, message: '请输入使用范围', trigger: 'blur'}
          ],
          deviceInstallTime: [
            {required: true, message: '请选择安装时间', trigger: 'blur'}
          ],
          deviceCheckTime: [
            {required: true, message: '请选择检查合格时间', trigger: 'blur'}
          ]
        },
        commander: null,
        commanders: [],
        drivers: [],
        driver: null,
        teamList: [],
        proId:null,
        proList:[],
      }
    },
    methods: {
      doSubmit: function (option) {
        this.formObj.deviceCommandeId = this.commander;
        this.formObj.deviceDriverId = this.driver;
        this.formObj.proId = this.proId;

        this.$refs.formObj.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {type: 'warning'}).then(() => {
              if (option == 0) {
                deviceCreate(this.formObj, this.GLOBAL.header).then(result => {
                  if (result.success) {
                    this.$message({
                      message: "添加成功",
                      type: 'success'
                    });
                    this.$emit('doSubmit');
                  }
                });
              }
              else if (option == 1) {
                deviceUpdate(this.formObj, this.GLOBAL.header).then(result => {
                  if (result.success) {
                    this.$message({
                      message: "修改成功",
                      type: 'success'
                    });
                    this.$emit('doSubmit');
                  }
                });
              }
            }).catch(() => {
            });
          }
        });
      },
      doCancel:function(){
        this.$emit('doCancel');
      },
      successConUpload:function(response){
        this.formObj.deviceEnclosure = response.data;
      },
      removeConUpload:function(){
        this.formObj.deviceEnclosure=null;
      },
      //上传限制
      handleExceed: function (files,fileList) {
        this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      proChange:function(){
        //塔吊司机
        workers({key:this.GLOBAL.roleTag.craneDriver,comId:this.GLOBAL.user.comId,proId: this.proId},this.GLOBAL.header).then(result => {
          if(result.success){
            this.driver = null;
            this.drivers = [];
            this.drivers = result.data;
            if(this.option ==1 && this.drivers.length >0)
            {
              this.driver = parseInt(this.formObj.deviceDriverId);
            }
          }
        });
        //塔吊指挥
        workers({key:this.GLOBAL.roleTag.craneCommander,comId:this.GLOBAL.user.comId,proId: this.proId},this.GLOBAL.header).then(result => {
          if(result.success){
            this.commander = null;
            this.commanders = [];
            this.commanders = result.data;
            if(this.option ==1 && this.commanders.length >0)
            {
              this.commander = parseInt(this.formObj.deviceCommanderId);
            }
          }
        });
      }
    },
    mounted () {
      //初始化数据
      //初始化表单数据
      this.formObj = this.formData;
      if (this.option == 1) {
        if(this.formObj.deviceEnclosure!=null && this.formObj.deviceEnclosure !=''){
          this.fileList.push({url: this.GLOBAL.basePhotoPath + '' + this.formObj.deviceEnclosure})
        }
      }
      //加载项目列表 如果 当前用户没有在任何项目  那么 加载 该用户所在公司及下属公司的所有项目
      if (this.GLOBAL.proList.length > 0) {
        this.proList = this.GLOBAL.proList;
        this.proId = this.proList[0].id;
        if(this.option==1)
        {
          this.proId = this.formObj.proId;
        }
        this.proChange();
      }else
      {
        let params = {
          page: 1,
          limit: 10000,
          comId: this.GLOBAL.user.comId == '' ? null : this.GLOBAL.user.comId
        };//请求参数
        proSearch(params, this.GLOBAL.header).then(result => {
          if (result.success) {
            this.proList = result.data.result;
            this.proId = this.proList[0].id;
            if(this.option==1)
            {
              this.proId = this.formObj.proId;
            }
            this.proChange();
          }
        });
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/device/RegisterForm.vue